import { Box, Tabs, Tab, useTheme } from '@mui/material';
import { Person, Settings, Palette, InfoOutlined, Shield } from '@mui/icons-material';
import { observer } from 'mobx-lite';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Color from 'color';
import IdentityServerConfig from './IdentityServerConfig';
import GeneralSettings from './GeneralSettings';
import { EventThemesManager } from './EventThemesManager';
import AboutTab from './AboutTab';
import GuardModeSettings from './GuardModeSettings';

const tabMap = ['general', 'identities', 'themes', 'guard', 'about'] as const;

const tabIconBadge = (accentColor: string) => ({
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, ${Color(accentColor).alpha(0.2).hexa()}, ${Color(accentColor).alpha(0.05).hexa()})`,
    border: `1px solid ${Color(accentColor).alpha(0.25).hexa()}`,
    flexShrink: 0,
});

const Setup: React.FC = observer(() => {
    const navigate = useNavigate();
    const location = useLocation();
    const muiTheme = useTheme();
    const accent = muiTheme.palette.primary.main;

    const getActiveTab = () => {
        const currentPath = location.pathname;
        if (currentPath.includes('/setup/identities')) return 1;
        if (currentPath.includes('/setup/themes')) return 2;
        if (currentPath.includes('/setup/guard')) return 3;
        if (currentPath.includes('/setup/about')) return 4;
        return 0; // general default
    };

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        navigate(`/setup/${tabMap[newValue]}`);
    };

    return (
        <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Tabs value={getActiveTab()} onChange={handleTabChange}>
                <Tab icon={<Box sx={tabIconBadge(accent)}><Settings sx={{ fontSize: 16, color: accent }} /></Box>} label="General" />
                <Tab icon={<Box sx={tabIconBadge(accent)}><Person sx={{ fontSize: 16, color: accent }} /></Box>} label="Identities" />
                <Tab icon={<Box sx={tabIconBadge(accent)}><Palette sx={{ fontSize: 16, color: accent }} /></Box>} label="Themes" />
                <Tab icon={<Box sx={tabIconBadge(accent)}><Shield sx={{ fontSize: 16, color: accent }} /></Box>} label="Guard" />
                <Tab icon={<Box sx={tabIconBadge(accent)}><InfoOutlined sx={{ fontSize: 16, color: accent }} /></Box>} label="About" />
            </Tabs>

            <Box sx={{ pt: 2, flex: 1 }}>
                <Routes>
                    <Route path="/" element={<Navigate to="/setup/general" replace />} />
                    <Route path="/identities" element={<IdentityServerConfig />} />
                    <Route path="/general" element={<GeneralSettings />} />
                    <Route path="/themes" element={<EventThemesManager />} />
                    <Route path="/guard" element={<GuardModeSettings />} />
                    <Route path="/about" element={<AboutTab />} />
                </Routes>
            </Box>
        </Box>
    );
});

export default Setup;
